module.exports = __webpack_public_path__ + "img/gardennw.859b0bfe.webp";